<template>
    <div class="notificaciones-solicitudes">
        <b-modal class="modal" centered content-class="modal-content" header-class="check-number-modal-header" dialog-class="modal-dialog" hide-footer size="lg" ref="notification_modal_details" title="Agregar información bancaria">
            <div class="info-wrapper notification-details d-flex flex-column">
                <div class="controls" v-if="NotificationModalStatus === 'pendiente' || NotificationModalStatus === 'pausada'">
                    <button @click="eliminarNotificacion" v-if="NotificationModalStatus === 'pendiente' || NotificationModalStatus === 'pausada'">Eliminar</button>
                    <button @click="pausarNotificacion" v-if="NotificationModalStatus === 'pendiente' && NotificationModalGroup === 'individual'">Pausar</button>
                    <button @click="reestablecerNotificacion" v-if="NotificationModalStatus === 'pausada'">Reestablecer</button>
                    <input type="date" v-model="changeDateNotifications" v-if="NotificationModalStatus === 'pendiente' || NotificationModalStatus === 'pausada' && NotificationModalGroup === 'individual'">
                    <button @click="changeDateNotificacion" v-if="NotificationModalStatus === 'pendiente' || NotificationModalStatus === 'pausada' && NotificationModalGroup === 'individual'">Cambiar Fecha</button>
                </div>
                <h3 for="">{{NotificationModalTitle}}</h3>
                <label for="">Fecha creacion: <span>{{NotificationModalCreated ? NotificationModalCreated.split($store.state.constants.SEPARETOR)[0] : NotificationModalCreated}}</span></label>
                <label v-if="NotificationModalSendTime !== null">Fecha entrega: <span>{{NotificationModalSendTime ? NotificationModalSendTime.split($store.state.constants.SEPARETOR)[0] : NotificationModalSendTime}}</span></label>
                <label for="">Tipo: <span>{{NotificationModalType}}</span></label>
                <label for="">Estado: <span>{{NotificationModalStatus}}</span></label>
                <label for="">Creada por: <span>{{NotificationModalWho}}</span></label>
                <label for="">Grupo: <span>{{NotificationModalGroup}}</span></label>
                <label for="">Motivo: <span>{{NotificationModalDetails}}</span></label>
            </div>
        </b-modal>
        <b-modal class="modal" centered content-class="modal-content" header-class="check-number-modal-header" dialog-class="modal-dialog" hide-footer size="lg" ref="modal_ingreso" title="Agregar información bancaria">
            <div class="info-wrapper d-flex flex-column align-items-center">
                <div>
                    <label for="">Fecha desde que elabora</label>
                    <input type="date" v-model="date">
                </div>
                <div>
                    <label for="">Monto</label>
                    <input type="number" v-model="cant">
                </div>
                <button @click="GenerateDocument(item)">Generar</button>
            </div>
        </b-modal>
        <div class="solicitudes">
            <div class="certificate">
                <div>
                    <div class="bancario">
                        <div>
                            <button @click="bancario">Certificado Bancario</button>
                        </div>
                    </div>
                    <div class="ingresos">
                        <div>
                            <button @click="ingresos">Certificado Ingresos</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="pending">
                <div>
                    <center>
                        <h3>Solicitudes pendientes</h3>
                        <table v-if="pending.length > 0">
                            <thead>
                                <tr>
                                    <th>Fecha</th>
                                    <th>No Solicitud</th>
                                    <th>Tipo de documento</th>
                                    <th>Aprobar</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in pending" :key="index">
                                    <td>{{item.created_at.split(this.$store.state.constants.SEPARETOR)[0]}}</td>
                                    <td>{{item.id}}</td>
                                    <td>{{item.type}}</td>
                                    <td>
                                        <button v-if="item.type === 'bancario'" @click="GenerateDocument(item.id)">Generar</button>
                                        <button v-else @click="openIngresoModal(item.id)">Generar</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div v-if="pending.length === 0"><h3>No hay documentos pendientes</h3></div>
                    </center>
                </div>
            </div>
            <div class="products">
                <div>
                    <center>
                        <h3>Solicitudes eliminación</h3>
                        <div class="table" v-if="products.length > 0">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Fecha</th>
                                        <th>Recepsionista</th>
                                        <th>Producto</th>
                                        <th>Cantidad</th>
                                        <th>Detalles</th>
                                        <th>Aprobar</th>
                                        <th>Rechazar</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in products" :key="index">
                                        <td>{{item.created_at.split(this.$store.state.constants.SEPARETOR)[0]}}</td>
                                        <td>{{item.who}}</td>
                                        <td>{{item.name}}</td>
                                        <td>{{item.cantidad}}</td>
                                        <td>{{item.detalles}}</td>
                                        <td><button @click="aprobarProducto(item.id)">Aprobar</button></td>
                                        <td><button @click="rechazarProducto(item.id)">Rechazar</button></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div v-if="products.length === 0"><h3>No hay productos pendientes para eliminar</h3></div>
                    </center>
                </div>
            </div>
        </div>
        <div class="notificaciones">
            <div class="table">
                <center>
                    <h3>Notificaciones Creadas</h3>
                    <div v-if="notificaciones.length > 0">
                        <table>
                            <thead>
                                <tr>
                                    <th>Creación</th>
                                    <th>titulo</th>
                                    <th>Estado</th>
                                    <th>Detalles</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in notificaciones" :key="index">
                                    <td>{{item.created_at.split(this.$store.state.constants.SEPARETOR)[0]}}</td>
                                    <td>{{item.titulo}}</td>
                                    <td>{{item.status}}</td>
                                    <td><button @click="notificationsDetails(item)">Detalles</button></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div v-if="notificaciones.length === 0" class="aviso"><h3>No hay notificaciones pendientes</h3></div>
                </center>
            </div>
            <div class="control">
                <center><h3>Crear notificación individual</h3></center>
                <div>
                    <div>
                        <label for="">Titulo</label>
                        <input type="text" name="" id="" v-model="titleNotification">
                        <label for="">Detalles</label>
                        <textarea name="" id="" cols="30" rows="5" v-model="detailsNotification"></textarea>
                    </div>
                    <div>
                        <label for="">Tipo</label>
                        <select name="" id="" v-model="typeNotification">
                            <option :value="item.name" v-for="(item, index) in notificacionesTypes" :key="index">{{item.name}}</option>
                        </select>
                        <label for="">Fecha entrega</label>
                        <input type="date" name="" id="" v-model="dateNotification">
                        <div><input type="checkbox" name="" id="" ref="deliveryNow"><label for="">Entregar Inmediatamente</label></div>
                    </div>
                </div>
                <center><button @click="createIndividualNotice">Crear notificacion</button></center>
            </div>
        </div>
    </div>
</template>

<script>
import API from '@/api'

export default {
    name: 'notificaciones-solicitudes',
    data() {
        return {
            titleNotification: null,
            detailsNotification: null,
            typeNotification: null,
            dateNotification: null,
            pending: [],
            products: [],
            cant: null,
            date: null,
            notificaciones: [],
            notificacionesTypes: [],
            NotificationModalTitle: null,
            NotificationModalType: null,
            NotificationModalStatus: null,
            NotificationModalWho: null,
            NotificationModalGroup: null,
            NotificationModalDetails: null,
            NotificationModalCreated: null,
            NotificationModalSendTime: null,
            NotificacionModalID: null,
            changeDateNotifications: null
        }
    },
    beforeMount() {
        this.$root.$emit('changeModel', this.$route.name)
    },
    methods: {
        eliminarNotificacion() {
            API.deleteNotificationByModel(this.$route.params.admin_id, this.NotificacionModalID)
                .then((res) => {
                    this.$refs.notification_modal_details.hide()
                    this.getNotificationsModel()
                })
        },
        pausarNotificacion() {
            API.pauseNotificationByModel(this.$route.params.admin_id, this.NotificacionModalID)
                .then((res) => {
                    this.getNotificationsModel()
                    this.NotificationModalStatus = res
                })
        },
        reestablecerNotificacion() {
            API.resetNotificationByModel(this.$route.params.admin_id, this.NotificacionModalID)
                .then((res) => {
                    this.getNotificationsModel()
                    this.NotificationModalStatus = res
                })
        },
        changeDateNotificacion() {
            if (this.changeDateNotifications === null) {
                return
            }
            API.changeDateNotificationByModel(this.$route.params.admin_id, this.NotificacionModalID, {newDate: this.changeDateNotifications})
                .then((res) => {
                    this.getNotificationsModel()
                    this.NotificationModalSendTime = res
                })
        },
        notificationsDetails(item) {
            this.NotificacionModalID = item.id
            this.NotificationModalSendTime = item.time_send
            this.NotificationModalCreated = item.created_at
            this.NotificationModalTitle = item.titulo
            this.NotificationModalType = item.type
            this.NotificationModalStatus = item.status
            this.NotificationModalWho = item.who
            this.NotificationModalGroup = item.group
            this.NotificationModalDetails = item.motivo
            this.$refs.notification_modal_details.show()
        },
        NotificationsTypes() {
            API.NotificationsTypes()
                .then((res) => {
                    this.notificacionesTypes = res
                })
        },
        createIndividualNotice() {
            if (this.typeNotification === null) {
                return
            }
            if (this.titleNotification === null) {
                return
            }
            if (this.detailsNotification === null) {
                return
            }
            if (this.dateNotification === null && !this.$refs.deliveryNow.checked) {
                return
            }
            var info = {
                type: this.typeNotification,
                title: this.titleNotification,
                details: this.detailsNotification,
                date: this.dateNotification,
                who: this.$store.state.user.id,
                delivery: this.$refs.deliveryNow.checked
            }
            API.createIndividualNotice(this.$route.params.admin_id, info)
                .then((res) => {
                    this.typeNotification = null
                    this.titleNotification = null
                    this.detailsNotification = null
                    this.dateNotification = null
                    this.getNotificationsModel()
                })
        },
        aprobarProducto(id) {
            API.removeProductLedger(id)
                .then((res) => {
                    this.products = []
                    this.getPendingProductsToDelete()
                })
        },
        rechazarProducto(id) {
            API.removeProductSolicitud(id)
                .then((res) => {
                    this.products = []
                    this.getPendingProductsToDelete()
                })
        },
        getPendingDocumentsByModel() {
            API.getPendingDocumentsByModel(this.$route.params.admin_id)
                .then((res) => {
                    this.pending = res
                })
        },
        bancario() {
            API.getBankCertificate(this.$route.params.admin_id)
                .then((res) => {
                    window.open(res.link, '_blank')
                })
        },
        ingresos() {
            API.getSalaryCertificate(this.$route.params.admin_id)
                .then((res) => {
                    window.open(res.link, '_blank')
                })
        },
        openIngresoModal(id) {
            this.$refs.modal_ingreso.show()
            this.item = id
        },
        GenerateDocument(id) {
            if (id === 'ingresos' && (this.cant === null || this.date === null)) {
                return
            }
            var info = {
                cant: this.cant,
                date: this.date
            }
            API.generateDocument(id, info)
                .then((res) => {
                    this.getPendingDocumentsByModel()
                    this.$refs.modal_ingreso.hide()
                })
        },
        getPendingProductsToDelete() {
            API.getPendingProductsToDelete(this.$route.params.admin_id)
                .then((res) => {
                    this.products = res
                })
        },
        getNotificationsModel() {
            API.getNotificationsModel(this.$route.params.admin_id)
                .then((res) => {
                    this.notificaciones = res
                })
        }
    },
    mounted() {
        this.getPendingDocumentsByModel()
        this.getPendingProductsToDelete()
        this.getNotificationsModel()
        this.NotificationsTypes()
    }
}
</script>

<style scoped>
    .notificaciones-solicitudes {
        width: 100%;
        height: 78vh;
        background-color: #cdcdcd;
        display: flex;
    }
    .notificaciones-solicitudes > .solicitudes {
        width: 50%;
        height: 100%;
    }
    .notificaciones-solicitudes > .solicitudes > .certificate {
        width: 100%;
        height: 20%;
        padding: 20px;
    }
    .notificaciones-solicitudes > .solicitudes > .certificate > div{
        height: 100%;
        width: 100%;
    }
    .notificaciones-solicitudes > .solicitudes > .certificate > div > .bancario {
        width: 100%;
        height: 50%;
        padding: 20px;
        position: relative;
    }
    .notificaciones-solicitudes > .solicitudes > .certificate > div > .ingresos {
        width: 100%;
        height: 50%;
        padding: 20px;
        position: relative;
    }
    .notificaciones-solicitudes > .solicitudes > .certificate > div > .bancario > div{
        width: 100%;
        height: 50%;
        border-radius: 20px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .notificaciones-solicitudes > .solicitudes > .certificate > div > .ingresos > div{
       width: 100%;
       height: 50%;
       border-radius: 20px;
       position: absolute;
       top: 50%;
       left: 50%;
       transform: translate(-50%, -50%);
    }
    .notificaciones-solicitudes > .solicitudes > .certificate > div > .ingresos > div > button {
        margin: auto;
        margin-bottom: 0px;
        background-color: #e0b059;
        color: #fff;
        width: 100%;
        height: 40px;
        border-radius: 30px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        border-style: outset;
    }
    .notificaciones-solicitudes > .solicitudes > .certificate > div > .bancario > div > button {
        margin: auto;
        margin-bottom: 0px;
        background-color: #e0b059;
        color: #fff;
        width: 100%;
        height: 40px;
        border-radius: 30px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        border-style: outset;
    }
    .notificaciones-solicitudes > .solicitudes > .pending {
        width: 100%;
        height: 40%;
        padding: 10px;
    }
    .notificaciones-solicitudes > .solicitudes > .pending > div {
        width: 100%;
        height: 100%;
        background-color: #63b1b7;
        border-radius: 20px;
        border-style: outset;
    }
    .notificaciones-solicitudes > .solicitudes > .pending > div > center {
        height: 100%;
        width: 100%;
        padding: 20px;
    }
    .notificaciones-solicitudes > .solicitudes > .pending > div > center > h3 {
        color: #fff;
    }
    .notificaciones-solicitudes > .solicitudes > .pending > div > center > div {
        position: relative;
        width: 100%;
        height: 60%;
    }
    .notificaciones-solicitudes > .solicitudes > .pending > div > center > table > thead > tr > th {
        padding: 10px;
        text-align: center;
        color: #fff;
        border-style: outset;
        background-color: #86672e;
    }
    .notificaciones-solicitudes > .solicitudes > .pending > div > center > table > tbody > tr > td {
        padding: 10px;
        text-align: center;
        border-style: inset;
    }
    .notificaciones-solicitudes > .solicitudes > .pending > div > center > table > tbody > tr > td > button {
        margin: auto;
        margin-bottom: 0px;
        background-color: #e0b059;
        color: #fff;
        width: 100%;
        border-radius: 30px;
    }
    .notificaciones-solicitudes > .solicitudes > .pending > div > center > div > h3 {
        color: #000;
        background-color: #fff;
        width: 100%;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
    }
    .notificaciones-solicitudes > .solicitudes > .products {
        width: 120%;
        height: 40%;
        padding: 10px;
    }
    .notificaciones-solicitudes > .solicitudes > .products > div {
        width: 100%;
        height: 100%;
        background-color: #8363b7;
        border-radius: 20px;
        border-style: outset;
    }
    .notificaciones-solicitudes > .solicitudes > .products > div > center {
        height: 100%;
        width: 100%;
        padding: 20px;
    }
    .notificaciones-solicitudes > .solicitudes > .products > div > center > h3 {
        color: #fff;
    }
    .notificaciones-solicitudes > .solicitudes > .products > div > center > div {
        position: relative;
        width: 100%;
        height: 60%;
        overflow-y: auto;
    }
    .notificaciones-solicitudes > .solicitudes > .products > div > center > div.table {
        margin-top: 10px;
        overflow-y: auto;
        height: 80%;
    }
    .notificaciones-solicitudes > .solicitudes > .products > div > center > div > table > thead > tr > th {
        padding: 10px;
        text-align: center;
        color: #fff;
        border-style: outset;
        background-color: #86672e;
    }
    .notificaciones-solicitudes > .solicitudes > .products > div > center > div > table > tbody > tr > td {
        padding: 10px;
        text-align: center;
        border-style: inset;
    }
    .notificaciones-solicitudes > .solicitudes > .products > div > center > div > table > tbody > tr > td > button {
        margin: auto;
        margin-bottom: 0px;
        background-color: #e0b059;
        color: #fff;
        width: 100%;
        border-radius: 30px;
    }
    .notificaciones-solicitudes > .solicitudes > .products > div > center > div > h3 {
        color: #000;
        background-color: #fff;
        width: 100%;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
    }
    .notificaciones-solicitudes > .notificaciones {
        width: 50%;
        height: 100%;
        padding: 10px;
        padding-bottom: 20px;
    }
    .notificaciones-solicitudes > .notificaciones > .table {
        background-color: #585858;
        width: 100%;
        height: 50%;
        padding: 20px;
        border-radius: 20px;
        border-style: outset;
    }
    .notificaciones-solicitudes > .notificaciones > .table > center {
        position: relative;
        width: 100%;
        height: 100%;
    }
    .notificaciones-solicitudes > .notificaciones > .table > center > h3{
        color: #fff;
        margin-bottom: 20px;
    }
    .notificaciones-solicitudes > .notificaciones > .table > center > .aviso {
        position: relative;
        width: 100%;
        height: 80%;
    }
    .notificaciones-solicitudes > .notificaciones > .table > center > .aviso > h3{
        background-color: #fff;
        position: absolute;
        top: 50%;
        left: 50%;
        width: 100%;
        transform: translate(-50%, -50%);
    }
    .notificaciones-solicitudes > .notificaciones > .table > center > div {
        overflow-y: auto;
        height: 80%;
    }
    .notificaciones-solicitudes > .notificaciones > .table > center > div > table > thead > tr > th{
        color: #fff;
        background-color: #5f5f5f;
        border-style: inset;
    }
    .notificaciones-solicitudes > .notificaciones > .table > center > div > table > tbody > tr > td{
        color: #fff;
        border-style: inset;
    }
    .notificaciones-solicitudes > .notificaciones > .table > center > div > table > tbody > tr > td > button{
        margin: auto;
        margin-bottom: 0px;
        background-color: #e0b059;
        color: #fff;
        width: 100px;
        height: 40px;
        border-radius: 30px;
    }
    .notificaciones-solicitudes > .notificaciones > .control {
        background-color: #b78863;
        width: 80%;
        height: 49%;
        padding: 10px;
        border-radius: 20px;
        float: right;
        border-style: outset;
    }
    .notificaciones-solicitudes > .notificaciones > .control > center > h3{
       color: #fff;
    }
    .notificaciones-solicitudes > .notificaciones > .control > center > button{
        margin: auto;
        margin-bottom: 0px;
        background-color: #e0b059;
        color: #fff;
        width: 180px;
        height: 40px;
        border-radius: 30px;
    }
    .notificaciones-solicitudes > .notificaciones > .control > div{
       display: flex;
       height: 70%;
    }
    .notificaciones-solicitudes > .notificaciones > .control > div > div{
       display: grid;
       padding: 20px;
       padding-left: 8%;
    }
    .notificaciones-solicitudes > .notificaciones > .control > div > div > label{
       color: #fff;
       font-weight: bold;
    }
    .notificaciones-solicitudes > .notificaciones > .control > div > div > input, select{
       width: 100%;
       height: 30px;
       border-radius: 20px;
       text-align: center;
    }
    .notificaciones-solicitudes > .notificaciones > .control > div > div > textarea{
       width: 100%;
       border-radius: 20px;
       text-align: center;
    }
    .notificaciones-solicitudes > .notificaciones > .control > div > div > div {
        display: flex;
    }
    .notificaciones-solicitudes > .notificaciones > .control > div > div > div > label {
        color: #fff;
        width: 100%;
        margin-left: 20px;
    }
    .info-wrapper > div {
        display: grid;
        padding: 20px;
    }
    .info-wrapper > div > label {
        font-weight: bold;
    }
    .info-wrapper > div > input {
        width: 250px;
        height: 40px;
        text-align: center;
        border-radius: 15px;
    }
    .info-wrapper > button {
        background-color: #e0b059;
        color: #fff;
        width: 150px;
        height: 60px;
        border-radius: 30px;
    }
    .notification-details {
        padding: 30px;
        padding-left: 60px;
        display: grid;
    }
    .notification-details > label{
        display: grid;
        font-size: 20px;
    }
    .notification-details > label > span{
        font-weight: bold;
    }
    .notification-details > .controls {
        width: 30%;
        position: absolute;
        right: 20px;
    }
    .notification-details > .controls > input{
        width: 100%;
    }
    .notification-details > .controls > button{
        margin: 20px;
        background-color: #e0b059;
        color: #fff;
        width: 150px;
        height: 40px;
        border-radius: 30px;
    }
</style>



// WEBPACK FOOTER //
// src/components/AdminsProfiles/AdminNotificacionesSolicitudes.vue